import React, { type FC } from 'react'

import { FormControl, InputLabel, MenuItem, Select, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

/**
 * Styled version of the FormControl component from Material-UI for
 * the TenantFilter component.
 */
const StyledFormControl = styled(FormControl)`
    min-width: 15em;
    margin: 0 3em 0 1em;
`

/**
 * Props for the TenantFilter component.
 *
 * @property tenants Array of tenant names to display in the dropdown.
 * @property selectedTenant  Currently selected tenant name.
 * @property onChange A callback function that is called when the selected tenant changes.
 * It receives the new tenant name as an argument.
 */
interface Props {
  tenants: string[]
  selectedTenant: string
  onChange: (newValue: string) => void
}

/**
 * Filter for selecting a tenant from a list of tenants.
 *
 * It displays a dropdown menu with the available tenants and allows the user to select one.
 */
export const TenantFilter: FC<Props> = ({
  tenants,
  selectedTenant,
  onChange
}) => {
  const { t } = useTranslation()

  return (
        <StyledFormControl variant="outlined" size="medium">
            <InputLabel>{t('deviceForProvision.tenantFilter')}</InputLabel>
            <Select value={selectedTenant} onChange={(e) => {
              onChange(e.target.value)
            }} label={t('deviceForProvision.tenantFilter')}>
                {tenants.map(tenant => (
                    <MenuItem value={tenant} key={tenant}>
                        {tenant}
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
  )
}
